import './initials-avatar.scss';

import React from 'react';

import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';

const iconSize = { sm: '16px', md: '24px', lg: '32px' };

export const InitialsAvatar = ({
  size = 'sm',
  initials,
  notificationCount,
  className,
}: {
  size?: 'sm' | 'md' | 'lg';
  initials?: string;
  notificationCount?: number;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'InitialsAvatar flex flex-col items-center justify-center relative text-center',
        {
          'InitialsAvatar--sm label-md label-potent': size === 'sm',
          'InitialsAvatar--md label-xl label-potent': size === 'md',
          'InitialsAvatar--lg heading-sm label-potent': size === 'lg',
        },
        className,
      )}
    >
      {initials ?? <ArkIcon iconName="user-01" size={iconSize[size]} />}
      {!!notificationCount && (
        <span className="InitialsAvatar__notificationCount absolute label-sm label-potent">
          {notificationCount}
        </span>
      )}
    </div>
  );
};
